export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11150.0e84ddd0.jpg";